import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegadoConvertStringToDatePipe } from './convert-string-to-date.pipe';
import { CapitalizeFirstLetterEachWordPipe } from './capitalize-first-letter-each-word.pipe';
import { FirstAndLastNamePipe } from './first-and-last-name.pipe';
import { ReduceDecimalsPipe } from './reduce-decimals.pipe';
import { DateAndTimePipe } from './date-and-time.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { IsQuestionEmptyPipe, IsTextEmptyPipe } from './is-text-empty.pipe';
import { AsMultValues, AsTableBtns, GenerateGridTemplate, RowsToSpan } from './table-helpers.pipe';
import { PhysicalDisability } from './patient-info-helpers.pipe';
import { IsSameDatePipe, IsTodayPipe } from './is-same-date-pipe';
import { TruncateStringPipe } from './truncate-string';
import { BoldSpanPipe } from './bold-style-to-substring';
import { DateIntervalPipe } from './date-interval.pipe';
import { HighlightWordPipe } from './highlight-word.pipe';
import { PrepareWordPipe } from './prepare-word.pipe';
import { LineBreaksPipe } from './line-breaks.pipe';
import { FormatUserNamePipe } from './format-user-name.pipe';



@NgModule({
  declarations: [
    LegadoConvertStringToDatePipe,
    DateAndTimePipe,
    CapitalizeFirstLetterEachWordPipe,
    BoldSpanPipe,
    FirstAndLastNamePipe,
    DateIntervalPipe,
    ReduceDecimalsPipe,
    SafeUrlPipe,
    AsTableBtns, GenerateGridTemplate, AsMultValues, RowsToSpan, TruncateStringPipe,
    IsTextEmptyPipe, IsQuestionEmptyPipe, IsSameDatePipe, IsTodayPipe,
    PhysicalDisability,
    HighlightWordPipe,
    PrepareWordPipe,
    LineBreaksPipe,
    FormatUserNamePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LegadoConvertStringToDatePipe, TruncateStringPipe,
    DateAndTimePipe,
    CapitalizeFirstLetterEachWordPipe,
    BoldSpanPipe,
    PhysicalDisability,
    DateIntervalPipe,
    FirstAndLastNamePipe,
    ReduceDecimalsPipe, GenerateGridTemplate,
    SafeUrlPipe,
    AsTableBtns, AsMultValues, RowsToSpan,
    IsTextEmptyPipe,
    IsQuestionEmptyPipe, IsSameDatePipe, IsTodayPipe,
    HighlightWordPipe,
    PrepareWordPipe,
    LineBreaksPipe,
    FormatUserNamePipe
  ]
})
export class PipesModule { }
